module.exports = __webpack_public_path__ + "img/openImage.34b7c48a.svg";